var React = require('react');

function CancelButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11.5","cy":"11.5","r":"11.5","fill":"#CCC","key":0}),React.createElement("g",{"stroke":"#FFF","strokeLinecap":"round","strokeWidth":".767","key":1},React.createElement("path",{"d":"M15.717 7.667l-8.132 8.131M7.283 7.667l8.132 8.131"}))]);
}

CancelButton.displayName = "CancelButton";

CancelButton.defaultProps = {"width":"23","height":"23"};

module.exports = CancelButton;

CancelButton.default = CancelButton;
